var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.092,
    height: 6.546,
    viewBox: "0 0 11.092 6.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto-fleche-dropdown",
    transform: "translate(-27.624 -13.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_831",
    "data-name": "Trac\\xE9 831",
    d: "M11.789,3.526,7.657,7.658,3.526,3.526",
    transform: "translate(25.512 11.683)",
    fill: "none",
    stroke: "#60798b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectDropdown);
export default __webpack_public_path__ + "static/media/icon-select-dropdown.f9d71f8c68c95e395a56068b2443372b.svg";
export { ForwardRef as ReactComponent };